var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 0.380859L23.7621 7.19038V20.8094L12.0002 27.619L0.238281 20.8094V7.19038L12.0002 0.380859ZM12.0002 3.2421L2.71447 8.61791V19.3819L12.0002 24.7577L21.2859 19.3819V8.61791L12.0002 3.2421ZM12.0002 18.9523C10.6867 18.9523 9.42708 18.4305 8.49832 17.5018C7.56957 16.573 7.04781 15.3134 7.04781 13.9999C7.04781 12.6865 7.56957 11.4268 8.49832 10.498C9.42708 9.56929 10.6867 9.04753 12.0002 9.04753C13.3136 9.04753 14.5733 9.56929 15.502 10.498C16.4308 11.4268 16.9526 12.6865 16.9526 13.9999C16.9526 15.3134 16.4308 16.573 15.502 17.5018C14.5733 18.4305 13.3136 18.9523 12.0002 18.9523ZM12.0002 16.4761C12.6569 16.4761 13.2867 16.2152 13.7511 15.7508C14.2155 15.2865 14.4764 14.6566 14.4764 13.9999C14.4764 13.3432 14.2155 12.7134 13.7511 12.249C13.2867 11.7846 12.6569 11.5237 12.0002 11.5237C11.3435 11.5237 10.7136 11.7846 10.2493 12.249C9.78488 12.7134 9.524 13.3432 9.524 13.9999C9.524 14.6566 9.78488 15.2865 10.2493 15.7508C10.7136 16.2152 11.3435 16.4761 12.0002 16.4761Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/SettingIcon.ff0fcc99438fc2096294f04ce3cca40c.svg";
export { ForwardRef as ReactComponent };